import React, { useEffect, useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Industries } from './components/Industries';
import { VideoShowcase } from './components/VideoShowcase';
import { Pricing } from './components/Pricing';
import { Results } from './components/Results';
import { Footer } from './components/Footer';
import { OfferPopup } from './components/OfferPopup';
import { motion, useScroll, useSpring, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';
export function App() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  const [showScrollTop, setShowScrollTop] = useState(false);
  useEffect(() => {
    // Ensure page starts at the top on load/refresh
    window.scrollTo(0, 0);
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="relative min-h-screen bg-brand-dark selection:bg-brand-accent selection:text-brand-dark" data-id="element-0">
      {/* Progress Bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-1 bg-brand-accent z-[60] origin-left" style={{
      scaleX
    }} data-id="element-1" />

      <Navbar data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Services data-id="element-6" />
        <Results data-id="element-7" />
        <Industries data-id="element-8" />
        <VideoShowcase data-id="element-9" />
        <Pricing data-id="element-10" />

        {/* Final CTA Section */}
        <section id="scale-business" className="py-12 lg:py-24 relative overflow-hidden" data-id="element-11">
          <div className="container mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-12">
            <motion.div initial={{
            opacity: 0,
            y: 30,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            y: 0,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="max-w-4xl mx-auto p-8 sm:p-10 lg:p-16 rounded-[2rem] lg:rounded-[3rem] bg-gradient-to-br from-brand-accent/20 to-transparent border border-brand-accent/20 backdrop-blur-sm" data-id="element-13">
              <h2 className="text-3xl sm:text-4xl md:text-6xl font-serif font-bold text-white mb-6 lg:mb-8" data-id="element-14">
                Let's Scale Your Business
              </h2>
              <p className="text-lg sm:text-xl text-slate-300 mb-8 lg:mb-12 max-w-2xl mx-auto" data-id="element-15">
                Stop managing operations and start building your business. Book
                a 30-minute discovery call today.
              </p>
              <a href="#book-call" className="inline-block bg-brand-accent text-brand-dark px-8 py-4 lg:px-10 lg:py-5 rounded-2xl font-black text-lg lg:text-xl hover:bg-white transition-all transform hover:scale-105 shadow-2xl shadow-brand-accent/20" data-id="element-16">
                Book Discovery Call
              </a>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer data-id="element-17" />

      <OfferPopup data-id="element-18" />

      <AnimatePresence data-id="element-19">
        {showScrollTop && <motion.button initial={{
        opacity: 0,
        y: 20,
        scale: 0.8
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.8
      }} whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.9
      }} onClick={scrollToTop} className="fixed bottom-8 right-8 z-50 p-4 rounded-full bg-brand-accent text-brand-dark shadow-2xl shadow-brand-accent/20 hover:bg-white transition-colors" aria-label="Scroll to top" data-id="element-20">
            <ArrowUp className="w-6 h-6" data-id="element-21" />
          </motion.button>}
      </AnimatePresence>
    </div>;
}